import { Seo } from "../components/onix/Seo";
import { SectionEyebrow } from "../components/onix/SectionEyebrow";
import { SecurityPrinciple } from "../components/onix/SecurityPrinciple";
import { Reveal } from "../components/onix/Reveal";
import { CTASection } from "../components/onix/CTASection";
import { getPrinciples, getGovernanceClosing } from "../data/principles";
import { useLang } from "../i18n/LanguageContext";

export default function Seguridad() {
  const { lang, t } = useLang();
  const tg = t.seg;
  const principles = getPrinciples(lang);
  return (
    <main className="pt-[76px]">
      <Seo title={tg.seoTitle} description={tg.seoDesc} path="/seguridad-y-gobierno" />

      <section className="onix-shell py-20 md:py-32 border-b border-onix-line">
        <Reveal>
          <SectionEyebrow index="01" label={tg.label} />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold font-serif leading-[1.05] text-onix-white max-w-4xl mb-8">
            {tg.h1}
          </h1>
          <p className="text-base md:text-lg leading-relaxed text-onix-silver max-w-2xl">
            {tg.intro}
          </p>
        </Reveal>
      </section>

      <section className="onix-shell py-20 md:py-28">
        <Reveal>
          <SectionEyebrow index="02" label={tg.principlesLabel} />
        </Reveal>
        <div className="border-b border-onix-line">
          {principles.map((p, i) => (
            <Reveal key={p.num} delay={Math.min(i * 0.03, 0.2)}>
              <SecurityPrinciple num={p.num} title={p.title} desc={p.desc} />
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-onix-line bg-onix-black2">
        <div className="onix-shell py-24 md:py-36">
          <Reveal>
            <blockquote data-testid="governance-closing" className="max-w-3xl">
              <p className="font-serif font-bold text-2xl md:text-4xl leading-snug text-onix-white">
                «{getGovernanceClosing(lang)}»
              </p>
            </blockquote>
          </Reveal>
        </div>
      </section>

      <CTASection
        index="03"
        label={t.common.contactoLabel}
        title={tg.ctaTitle}
        text={tg.ctaText}
        buttonLabel={t.common.solicitarDemo}
        to="/contacto"
      />
    </main>
  );
}
